import { Helper } from '../../main';
var MaskPresetConfig = /** @class */ (function () {
    function MaskPresetConfig() {
        this.isValid = null;
        this.value = null;
    }
    MaskPresetConfig.prototype.getterTransform = function (input) {
        return input || this.value;
    };
    MaskPresetConfig.prototype.setterTransform = function (input) {
        this.value = Helper.toString(input);
        this.isValid = this.value.length === 0 ? null : true;
        return input;
    };
    return MaskPresetConfig;
}());
export { MaskPresetConfig };
//# sourceMappingURL=MaskPresetConfig.js.map